import {
  addQueryWithReplace, getLinkQueryParamUrl,
} from 'Helpers/Query';
import { EQUALS, IN } from 'Consts/queryParams';

// Filters out hidden filters from selected
export const hiddenBulkCommunicationFilters = ['agentId', 'offset', 'id', 'limit', 'sort'];
export const filtersToKeep = ['agentId', 'id'];

export function applyFilters(filters, resource, linkQueryParamName = 'bulkCommunicationLink', onApplyFilters = null) {
  const linkUrl = getLinkQueryParamUrl(resource, linkQueryParamName);

  const availableFilters = resource.meta().queries().head().template()
    .list()
    .map(filter => {
      return {
        name: filter.attr('name'),
        operator: filter.operators()?.head()?.id() || EQUALS,
      };
    });

  let filterString = '';
  availableFilters.forEach((availableFilter) => {
    const key = availableFilter.name;
    const value = filters[key];

    if (value !== null && value !== undefined && (!Array.isArray(value) || (value.length > 0))) {
      let operatorPrefix = '';
      if (availableFilter?.operator && availableFilter?.operator !== EQUALS && availableFilter.operator !== IN) {
        operatorPrefix = `${availableFilter.operator}|`;
      }

      if (!hiddenBulkCommunicationFilters.includes(key)) {
        if (filterString !== '') {
          filterString += '&';
        }
        filterString += `${key}=${operatorPrefix}${value.toString()}`;
      }

      linkUrl.searchParams.set(key, `${operatorPrefix}${value.toString()}`);
    } else if (!filtersToKeep.includes(key)) {
      linkUrl.searchParams.delete(key);
    }
  });
  linkUrl.searchParams.set('offset', '0');

  addQueryWithReplace({ [linkQueryParamName]: linkUrl.toString() });

  if (onApplyFilters) {
    onApplyFilters(filterString);
  }
  return linkUrl.toString();
}
